import { cn } from '@/utils/cn';
import type { SpinnerProps } from './Spinner.types';
import styles from './Spinner.module.scss';

export function Spinner({
  size = 'md',
  className,
  'aria-label': ariaLabel = 'Loading',
  ...props
}: SpinnerProps) {
  const spinnerClasses = cn(styles.spinner, styles[`spinner--${size}`], className);

  return (
    <div
      className={spinnerClasses}
      role="status"
      aria-label={ariaLabel}
      aria-live="polite"
      {...props}
    >
      <svg className={styles.spinner__svg} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <circle
          className={styles.spinner__circle}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
        />
      </svg>
    </div>
  );
}

export default Spinner;
